const AUTH_COOKIE_NAME = 'SESSION';

export { AUTH_COOKIE_NAME };
